// @flow strict

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import logo from '../../../../static/images/ansarada_logo_white.svg';
import ResponsiveImage from '../../../../internal/ResponsiveImage';
import styles from './styles.scss';

type PropsType = {|
  title?: string,
  subtitle?: string,
  subtitle2?: string,
  children: PropTypes.node,
  showLogo?: boolean,
  includeLogInLink: boolean,
  formImageDesktop?: string,
  formImageMobile?: string,
|};

const SignUpLayout = ({
  title,
  subtitle,
  subtitle2,
  children,
  includeLogInLink,
  showLogo = true,
  formImageDesktop,
  formImageMobile,
}: PropsType) => (
  <div className={styles.container}>
    <div className={styles.backdrop} />
    <div className={styles.content}>
      {showLogo && (
        <div className={styles.logoContainer}>
          <a href="/">
            <img className={styles.logo} src={logo} alt="Ansarada" width="176" height="23" />
          </a>
        </div>
      )}

      {title && <h1 className={styles.title}>{title}</h1>}

      <p className={styles.subtitle}>
        {subtitle}
        <br />
        {subtitle2}
      </p>

      <div className={cx(styles.form, styles.isSocialSignupEnabled)}>{children}</div>

      <div className={styles.footer}>
        {includeLogInLink && (
          <p>
            Already have an account? <a href="https://dash.ansarada.com">Log in.</a>
          </p>
        )}

        <p>
          <span>By signing up, you agree to our </span>
          <a href="https://www.ansarada.com/privacy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
          <span>, </span>
          <a
            href="https://www.ansarada.com/terms-conditions"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms and Conditions
          </a>
          <span> and </span>
          <a href="https://www.ansarada.com/gdpr" target="_blank" rel="noopener noreferrer">
            GDPR information
          </a>
          <span>. </span>
        </p>
        <p>
          This site is protected by reCAPTCHA and the Google{' '}
          <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>{' '}
          and{' '}
          <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">
            Terms of Service
          </a>{' '}
          apply.
        </p>
      </div>
    </div>

    {formImageDesktop && (
      <ResponsiveImage
        className={styles.bgDesktopImage}
        defaultSize={{ width: 1000 }}
        src={formImageDesktop}
      />
    )}
    {formImageMobile && (
      <ResponsiveImage
        className={styles.bgMobileImage}
        defaultSize={{ width: 767 }}
        src={formImageMobile}
      />
    )}
  </div>
);

export default SignUpLayout;
